// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"FileUploader_wrapperComponent__FCe79","button":"FileUploader_button__rmpS5","label":"FileUploader_label__2L9EU","file":"FileUploader_file__PHVO8"};